import React from 'react';
import { createRoot } from 'react-dom/client';
import PadaVista from './PadaVista';
import './styles.css';

const container = document.getElementById('id-pada-vista');
if (container) {
  const root = createRoot(container, {
  });
  root.render(
    <React.StrictMode>
      <div id="react-plugin-root">
        <PadaVista />
      </div>
    </React.StrictMode>
  );
} else {
  console.error('Error: El contenedor raíz para la aplicación React no fue encontrado.');
}